import { PointArray } from '@editor/interfaces/attribute'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface PlaneDetectionState {
  /**
   * Working points when drawing plane.
   */
  workingPoints: PointArray[]

  /**
   * Points of a plane being edited.
   */
  editingPoints: PointArray[]

  /**
   * Flag to indicate if the polygon is closing.
   */
  isClosing: boolean
}

const initialState: PlaneDetectionState = {
  workingPoints: [],
  editingPoints: [],
  isClosing: false,
}

export const slice = createSlice({
  name: 'blueprint-editor/tools/polygon',
  initialState,
  reducers: {
    /**
     * Add a new working point.
     */
    addWorkingPoint: (state, action: PayloadAction<PointArray>) => {
      state.workingPoints.push(action.payload)
    },

    /**
     * Set editing points.
     */
    setEditingPoints: (state, action: PayloadAction<PointArray[]>) => {
      state.editingPoints = action.payload
    },

    /**
     * Update a plane anchor.
     */
    updatePlaneAnchor: (state, action: PayloadAction<{ anchorIndex: number; position: PointArray }>) => {
      state.editingPoints[action.payload.anchorIndex] = action.payload.position

      // If first point is updated, update the last point as well, and vice versa.
      if (action.payload.anchorIndex === 0) {
        state.editingPoints[state.editingPoints.length - 1] = action.payload.position
      }

      if (action.payload.anchorIndex === state.editingPoints.length - 1) {
        state.editingPoints[0] = action.payload.position
      }
    },

    /**
     * Set closing state.
     */
    setIsClosing: (state, action: PayloadAction<boolean>) => {
      state.isClosing = action.payload
    },

    /**
     * Undo the last working plane, re-opening any completed ones if necessary.
     */
    // undoLastWorkingPlane: (state) => {
    //   if (state.workingPoints.length > 0) {
    //     state.workingPoints.pop()
    //   } else if (state.planes.length) {
    //     // take the last plane and make it the working plane, with all but the last point
    //     const lastPlane = state.planes.pop()
    //     if (lastPlane) {
    //       state.workingPoints = lastPlane.drawing_parameters.points.slice(0, -1) // remove the last two points
    //     }
    //   }

    //   state.isDirty = state.savingPlanes.length > 0 || state.workingPoints.length > 0
    // },

    undoWorkingPolygon: (state) => {
      state.workingPoints.pop()
    },

    /**
     * Reset
     */
    reset: () => initialState,
  },
})

export const {
  // ## Working plane
  setIsClosing,
  addWorkingPoint,

  // ## Editing plane
  setEditingPoints,
  updatePlaneAnchor,

  undoWorkingPolygon,
  reset,
} = slice.actions

export default slice.reducer
